export default {
  name: 'ClusterShader',

  vertexShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_vertex>
    attribute float vpsScore;
    varying float vVpsScore;
  
    void main() {
      vVpsScore = vpsScore;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      gl_PointSize = 5.0;
      #include <logdepthbuf_vertex>
    }`,

  fragmentShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_fragment>
    uniform sampler2D uGradientTexture;
    varying float vVpsScore;
  
    void main() {
      #include <logdepthbuf_fragment>
      vec2 texCoord = vec2(0.5, vVpsScore);
      vec4 color = texture2D(uGradientTexture, texCoord);
      gl_FragColor = vec4(color);
    }`,
}
